<template>
  <div>
    <van-nav-bar
      title="年度奖励"
      left-text=""
      left-arrow
      @click-left="onClickLeft()"
      style="margin-top: 10px"
    />
    <div v-if="!isLogined" style="padding-top: 300px">
      <p>您还没有登录哦，请先登录</p>
      <van-button round @click="ShowLogin" type="info">点击登录</van-button>
    </div>
    <div v-else>
      <!-- <van-nav-bar title="本阶段积分奖励" left-text="" left-arrow @click-left="onClickLeft()" />
        <van-notice-bar
          wrapable
          :scrollable="false"
          text="本阶段内，瑞家系列、顾家管、爱家系列、整体抗菌管丝口所产生的误工积分和
      绿色系列所产生的物资积分（管道米数大于30米记30积分）总和超过400即可参与。
      按每200额外奖励200物资积分，上不封顶。"
        />
        <van-cell-group style="margin-top:20px;"> 
          <van-cell title="阶段内丝口所产生的误工积分" :value="integral" />
          <van-cell title="绿色管产生的物资积分" :value="matintegral" />
          <van-cell title="奖励" :value="rewardIntegral" />
        </van-cell-group> -->
      <van-divider content-position="left">年度积分奖励</van-divider>
      <van-notice-bar wrapable :scrollable="false" style="text-align: left">
        年度误工积分奖励方式为丝口、大流量、前置等所产生的误工积分。
        <br />误工积分第一名，奖励10000元误工积分
        <br />误工积分第二名，奖励6000元误工积分
        <br />误工积分第三名，奖励4000元误工积分
      </van-notice-bar>
      <van-cell-group style="margin-top: 20px">
        <van-cell title="误工积分" :value="y_integral_total" />
      </van-cell-group>

      <van-divider content-position="left">年度油卡奖励</van-divider>
      <van-notice-bar wrapable :scrollable="false" style="text-align: left">
        年度油卡奖励方式为每单配套产品满足三种及以上，满足条件六单额外赠送一百元油卡
      </van-notice-bar>
      <van-cell-group style="margin-top: 20px">
        <van-cell title="满足三种及以上单量" :value="y_conditionNum" />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  NavBar,
  Grid,
  GridItem,
  NoticeBar,
} from "vant";
import { Button, Field } from "vant";
import { Divider } from "vant";
import { Popup } from "vant";
import { CountDown } from "vant";

export default {
  name: "StageIntegral",
  data() {
    return {
      y_integral_total: 0,
      // y_rewardIntegral: 0,
      y_conditionNum: 0,
      // y_rewardNum: 0,
      tel: null,
    };
  },
  props: {},
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    ShowLogin() {
      // this.$store.commit("showLogin");
      this.$router.push({
        name: "Login",
        params: {},
      });
    },
    // 查询阶段积分记录
    GetYearData() {
      var that = this;
      if (that.isLogined) {
        that.$http
          .get("SDWorker/GetYearMatIntegralByTel", {
            params: {
              sdworkertel: that.tel,
            },
          })
          .then((res) => {
            that.y_integral_total = res.data.Data.integral_total;
            // that.y_rewardIntegral = res.data.Data.rewardIntegral;
          });
      }
    },
    // 查询年度配套产品
    GetYearPro() {
      var that = this;
      if (that.isLogined) {
        that.$http
          .get("SDWorker/GetYearProductByTel", {
            params: {
              sdworkertel: that.tel,
            },
          })
          .then((res) => {
            that.y_conditionNum = res.data.Data.conditionNum;
            // that.y_rewardNum = res.data.Data.rewardNum;
          });
      }
    },
    // 返回
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  created() {
    this.tel = this.$route.params.tel;
    // this.GetData();
    this.GetYearData();
    this.GetYearPro();
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [CountDown.name]: CountDown,
    [NavBar.name]: NavBar,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [NoticeBar.name]: NoticeBar,
  },
};
</script>


<style scoped>
body {
  margin: 0;
  padding: 0;
}

.scroll-table-demo {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.scroll-table-title {
  height: 80px;
  line-height: 24px;
  font-weight: bold;
  background-color: #7fd75a;
  color: #fff;
  display: flex;
  align-items: center;
  padding-left: 20px;
}

/* 全局css配置 */
.scroll-table {
  height: calc(100% - 80px);
}

.scroll-table table {
  border: none;
  border-collapse: collapse;
}

.scroll-table td,
.scroll-table th {
  padding: 0;
}

.scroll-table-container {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.scroll-table-left,
.scroll-table-slider {
  display: flex;
  flex-direction: column;
  box-shadow: 1px 3px 5px #eee;
}

.scroll-table-left-top,
.scroll-table-slider-top {
  height: 45px;
  background-color: #f5f7fa;
  position: relative;
  z-index: 10;
}

.scroll-table-right-top {
  background-color: #f5f7fa;
}

.scroll-table-left-top div,
.scroll-table-slider div {
  width: 60px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}

.scroll-table-left-top tr,
.scroll-table-slider-top tr {
  border-bottom: 1px solid #ebeef5;
}

.scroll-table-left-freeze,
.scroll-table-slider-freeze {
  flex: 1;
  height: calc(100% - 45px - 45px);
}

.scroll-table-left-freeze tr,
.scroll-table-slider-freeze tr {
  border-bottom: 1px solid #ebeef5;
  box-sizing: border-box;
}

.scroll-table-left-freeze td > div,
.scroll-table-slider-freeze td > div {
  width: 60px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}

.scroll-table-left-bottom,
.scroll-table-slider-bottom {
  height: 45px;
  background-color: #f5f7fa;
  position: relative;
  z-index: 10;
}

.scroll-table-left-bottom tr,
.scroll-table-slider-bottom .tr {
  margin: 0;
  padding: 0;
}

.scroll-table-left-bottom th > div,
.scroll-table-slider-bottom th > div {
  width: 60px;
}

.scroll-table-right {
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  font-size: 13px;
}

.scroll-table-right-bottom {
  background-color: #1890ff;
  color: #fff;
}

.scroll-table-right-bottom td > div {
  width: 90px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}

.scroll-table-right-top tr {
  border-bottom: 1px solid #ebeef5;
  background-color: #f5f7fa;
}

.scroll-table-right-top th > div {
  width: 90px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}

.scroll-table-right-content {
  flex: 1;
  overflow: hidden;
}

.scroll-table-right-content tr {
  border-bottom: 1px solid #ebeef5;
}

.scroll-table-right-content td > div {
  width: 90px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}
.van-grid-item {
  height: 45px;
}
</style>
